export const handleAppError = (err: Error) => {
  console.error(err);
};
